// Wire-string mapping for the agency.registration.v1.RegistrationRole proto enum.
// Mirrors lib/agency/pkg/pineseed/client/register.go (roleWireNames); the proto
// enum is the single source of truth for the set of roles.

import { RegistrationRole } from "../../proto/gen/typescript/agency/registration/v1/registration";

export { RegistrationRole };

type WiredRole = Exclude<RegistrationRole, RegistrationRole.UNSPECIFIED>;

const ROLE_WIRE_NAMES = {
  [RegistrationRole.CLIENT]: "client",
  [RegistrationRole.HOOK_PROVIDER]: "hook-provider",
  [RegistrationRole.INFERENCE_PROVIDER]: "inference-provider",
  [RegistrationRole.CONTEXT_PROVIDER]: "context-provider",
  [RegistrationRole.TRACE_PROVIDER]: "trace-provider",
  [RegistrationRole.CLIENT_PROVIDER]: "client-provider",
  [RegistrationRole.SERVER]: "server",
} as const satisfies Record<WiredRole, string>;

export type RegistrationRoleWire = (typeof ROLE_WIRE_NAMES)[WiredRole];

const WIRED_ROLES: readonly WiredRole[] = Object.values(RegistrationRole).filter(
  (v): v is WiredRole => typeof v === "number" && v !== RegistrationRole.UNSPECIFIED,
);

const ROLE_WIRE_VALUES = new Map<string, WiredRole>();
for (const role of WIRED_ROLES) {
  const wire = (ROLE_WIRE_NAMES as Partial<Record<number, RegistrationRoleWire>>)[role];
  if (wire === undefined) {
    throw new Error(
      `registration-role: missing wire string for ${RegistrationRole[role]} (${role}) — add it to registration-role.ts`,
    );
  }
  const prev = ROLE_WIRE_VALUES.get(wire);
  if (prev !== undefined) {
    throw new Error(
      `registration-role: ${RegistrationRole[prev]} and ${RegistrationRole[role]} share wire string "${wire}"`,
    );
  }
  ROLE_WIRE_VALUES.set(wire, role);
}

const [firstWire, ...restWires] = WIRED_ROLES.map((role) => ROLE_WIRE_NAMES[role]);
if (firstWire === undefined) {
  throw new Error("registration-role: RegistrationRole enum defines no wired roles");
}

/** Every registration role wire string, in enum order (suitable for `z.enum`). */
export const REGISTRATION_ROLE_WIRES: readonly [RegistrationRoleWire, ...RegistrationRoleWire[]] = [
  firstWire,
  ...restWires,
];

/** Returns the wire string for role. Throws for UNSPECIFIED or any unmapped value. */
export function registrationRoleWire(role: RegistrationRole): RegistrationRoleWire {
  if (role === RegistrationRole.UNSPECIFIED) {
    throw new Error("registration-role: REGISTRATION_ROLE_UNSPECIFIED has no wire string");
  }
  const wire = (ROLE_WIRE_NAMES as Partial<Record<number, RegistrationRoleWire>>)[role];
  if (wire === undefined) {
    throw new Error(`registration-role: no wire string for registration role ${role}`);
  }
  return wire;
}

/** Maps an inbound wire string to its enum value. Throws on unknown strings. */
export function parseRegistrationRole(wire: string): WiredRole {
  const role = ROLE_WIRE_VALUES.get(wire);
  if (role === undefined) {
    throw new Error(`unknown registration role "${wire}"`);
  }
  return role;
}
